// Builds links to a person's profile in the sibling app EverHub. The Hub base
// URL is server config (EVERHUB_BASE_URL) surfaced to the client via
// <meta name="hub-base-url"> in the layout — mirroring lib/enums.js. Person rows
// already carry the Redmine user id as their `id`, and Hub exposes a live
// /users/by-redmine/<id> route that 302-redirects to the resolved profile.

// buildPersonProfileUrl is the PURE core: no DOM, fully unit-testable. Returns
// the profile URL when both a non-blank base and a positive integer-ish id are
// present, otherwise null so callers can fall back to a non-link.
export function buildPersonProfileUrl(hubBaseUrl, redmineId) {
  const base = String(hubBaseUrl ?? '').trim();
  if (base === '') return null;

  const id = String(redmineId ?? '').trim();
  if (id === '') return null;
  if (!/^\d+$/.test(id)) return null;
  if (Number(id) <= 0) return null;

  const trimmedBase = base.replace(/\/+$/, '');
  return `${trimmedBase}/users/by-redmine/${id}`;
}

// Cached for the page's lifetime — the meta tag is rendered once in the layout
// and never mutated (no SPA navigation swaps it).
let cachedBase;

function hubBaseUrl() {
  if (cachedBase !== undefined) return cachedBase;
  // Non-DOM/test context: degrade to null rather than crashing.
  if (typeof document === 'undefined') {
    cachedBase = null;
    return cachedBase;
  }
  const el = document.querySelector('meta[name="hub-base-url"]');
  cachedBase = (el && el.content) || null;
  return cachedBase;
}

// personProfileUrl is the thin DOM-aware wrapper: reads the meta once (cached)
// and defers to the pure builder. Returns null gracefully when the meta is
// absent so avatars/names render as plain (non-link) content.
export function personProfileUrl(redmineId) {
  return buildPersonProfileUrl(hubBaseUrl(), redmineId);
}
